<template>
  <screen
    v-show="show"
    :screen-name="screenName"
    :screen-info="$t('stamp.accessories_info')"
    :alt-info="$t('stamp.accessories_alt_info')"
    @skip="$emit('skip')"
  >
    <accessories dark />
  </screen>
</template>

<script>
import autoNext from '@/mixins/auto-next';
import incein from '@/mixins/incein';

import Screen from '../Screen.vue';
import Accessories from './Accessories.vue';

export default {
  name: 'ThingsToNote2',
  components: { Accessories, Screen },
  mixins: [autoNext, incein],
  data: () => ({
    duration: 9,
    audioKey: '9',
    playThrough: false,
  }),
  computed: {
    screenName() {
      return this.isIncein
        ? this.$t('incein.things_to_note_title')
        : this.$t('stamp.things_to_note_title');
    },
  },
};
</script>
